import { Component, OnInit } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';
import { Confirm_button } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromStore from '../../../store';
import { Store, select } from '@ngrx/store';
import * as fromFeature from '../../../my-features';
import * as moment from 'moment';
import { GateWaySnmpType, updateInfoType } from '../../../shareModel';
import {CryptoService} from '../../../services/crypto.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UpdateInfoModel } from '../../../my-features/updateInfo/update-info.model';

@Component({
  standalone: false,
  selector: 'app-gateway-mgt-list',
  templateUrl: './gateway-mgt-list.component.html',
  styleUrls: ['./gateway-mgt-list.component.css']
})
export class GatewayMgtListComponent implements OnInit {
  private componentDestroyed = new Subject();
  Confirm_button = Confirm_button;
  gatewayMgtList_cols: any[] = [
    { field: 'name', header: 'MIB Name', width: '200', class: 'col-nowrap', disabled: false },
    { field: 'brand', header: 'Brand', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'type', header: 'Type', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'updatetime', header: 'Update time', width: '150', class: 'col-nowrap', disabled: false },
    // { field: 'status', header: 'Status', width: '150', class: 'col-nowrap', disabled: false },
  ];
  gatewayMgtListDagta = [];
  gatewayMgtList = [];
  attributeMgtList_cols: any[] = [
    { field: 'name', header: 'Attribute Name', width: '200', class: 'col-nowrap', disabled: false },
    { field: 'fieldName', header: 'Field Name', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'category', header: 'Category', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'desc', header: 'Description', width: '420', class: 'col-nowrap', disabled: false },
  ];
  attributeMgtList = [];
  selectedAttribute: any;
  dialogInput: {
    Id?: number;
    UpdateType: string;
    name: string;
    fieldName: string;
    category: number;
    desc: string;
  };
  categoryOptions: SelectItem[] = [];
  displayDialog: boolean = false;
  displayConfirmDialog: boolean = false;
  gatewayAttributeByCategoryDic = [];
  gatewayCategoryDic = [];
  categoryList = [];
  UpdateInfoParam = {} as UpdateInfoModel;
  constructor(
    private store: Store<fromStore.State>,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,
    private ngxService: NgxUiLoaderService) { 

    // Get User Info
    this.store.pipe(select(fromStore.getCurrentUser)).subscribe(res => {
      if (res.authority && res.authority !== 2) {
        this.router.navigate(['/index']);
      }
    });
    this.ngxService.start();
    this.store.dispatch(new fromFeature.ReadMgtMibTrapList());
    this.store.dispatch(new fromFeature.ReadMgtAttribute());
    this.store.dispatch(new fromFeature.ReadCategoryListByUser());

    // Get Category List
    this.store
      .select(fromStore.ReadCategoryList)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined && res.length > 0) {
          this.categoryList = [];
          this.categoryOptions = [];
          // NgRx 9 不可變性: 創建數組副本再排序，避免修改只讀數組
          [...res].sort(function (a: any, b: any) {
            return a.Value - b.Value;
          }).map((c) => {
            this.categoryList.push(c)
            this.categoryOptions.push({
              label: c.Category, value: c.Value
            })
          })
        }
    });

    // Get Mib Trap List
    this.store
      .select(fromStore.ReadMgtMibTrapList)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined) {
          this.gatewayMgtListDagta = res;
          this.getGatewayMgtList(res)
          this.ngxService.stop();
        }
    });
    
    // Get Attribute
    this.store
      .select(fromStore.ReadMgtAttribute)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined) {
          this.gatewayMgtListDagta = res;
          this.getAttributeMgtList(res)
          this.ngxService.stop();
        }
    });

    // Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.isLoading && res.isLoaded) {
        if (res.type === updateInfoType.AddMgtAttribute || res.type === updateInfoType.UpdateMgtAttribute || res.type === updateInfoType.DeleteMgtAttribute) {
          this.messageService.clear();
          if (res.isSaved) {
            this.messageService.add({ severity: 'success', summary: res.msg });
          } else {
            this.messageService.add({ severity: 'error', summary: res.msg });
          }
          this.resetUpdateInfoState();
        }
      }
    })
  }


  ngOnInit() {
    this.initDialogInput();
  }

  getGatewayMgtList(miblist) {
    if (miblist !== undefined && miblist !== null && miblist.length > 0) {
      this.gatewayMgtList = [];
      const cryptoService = new CryptoService;
      miblist.map((s)=>{
        this.gatewayMgtList.push({
          id: s.Id,
          name: s.Name,
          brand: s.Brand,
          type: GateWaySnmpType[s.Type] !== undefined ? GateWaySnmpType[s.Type] : '',
          updatetime: s.UpdateTime !== null ? moment(Number(s.UpdateTime) * 1000).format('YYYY/MM/DD HH:mm:ss') : '',
          status: true,
          hashId: cryptoService.aesEncrypt(s.Id)
        })
      })
    }
  }

  getAttributeMgtList(attributelist) {
    if (attributelist !== undefined && attributelist.length > 0) {
      this.attributeMgtList = [];
      attributelist.map((s)=>{
        this.attributeMgtList.push({
          id: s.Id,
          name: s.AttrName,
          fieldName: s.FieldName,
          category: s.Category,
          desc: s.Description,
          updatetime: s.UpdateTime !== null ? moment(Number(s.UpdateTime) * 1000).format('YYYY/MM/DD HH:mm:ss') : '',
        })
      })
    }
  }

  initDialogInput() {
    this.dialogInput = {
      Id: 0,
      UpdateType: 'Add Attribute',
      name: '',
      fieldName: '',
      category: 0,
      desc: ''
    };
  }

  showDialog() {
    this.initDialogInput();
    this.displayDialog = true;
  }

  showEditDialog() {
    this.displayDialog = true;
    this.dialogInput = {
      Id: this.selectedAttribute.id,
      UpdateType: 'Edit Attribute',
      name: this.selectedAttribute.name,
      fieldName: this.selectedAttribute.fieldName,
      category: this.selectedAttribute.category,
      desc: this.selectedAttribute.desc,
    };
  }

  saveAttributeData() {
    if (this.dialogInput.UpdateType === 'Add Attribute') {
      const param = {
        otp : '',
        Category: this.dialogInput.category,
        AttrName: this.dialogInput.name,
        FieldName: this.dialogInput.fieldName,
        Description: this.dialogInput.desc
      }
      this.store.dispatch(new fromFeature.AddMgtAttribute(param));
    }
    else {
      const param = {
        otp : '',
        Id : this.dialogInput.Id,
        AttrName: this.dialogInput.name,
        FieldName: this.dialogInput.fieldName,
        Description: this.dialogInput.desc
      }
      this.store.dispatch(new fromFeature.UpdateMgtAttribute(param));
    }
    this.displayDialog = false;
  }

  showConfirmDialog() {
    this.displayConfirmDialog = true;
  }

  deleteAttributeData() {
    const param = {
      otp : '',
      Id : this.selectedAttribute.id
    }
    this.store.dispatch(new fromFeature.DeleteMgtAttribute(param));
    this.displayConfirmDialog = false;
  }

  handleChange(e) {
    this.saveGatewayStatus();
  }

  saveGatewayStatus() {

  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
